import React from "react";
import { Link } from "gatsby";
import EnteLogo from "images/main/logo";

const HomeLink: React.FC<{ url: string }> = ({ url }) => {
    return (
        <Link to={url} className="link-prominent" aria-label="Home">
            <EnteLogo className="w-[3.5rem] lg:w-20" />
        </Link>
    );
};

export default HomeLink;
